<template>
    <div id="inbox-content">
        <div class="content-header">
            <h2>Form Yanıtlanma Tarihi: {{ formattedDate }}</h2>
            <button class="button" @click="markAsRead" v-if="notReadBtn">Okundu Olarak işaretle</button>
        </div>
        <div class="content-body">
            <div class="info-item" v-for="(answer, index) in sortedAnswers" :key="index">
        <span class="label">
          {{ getLabelText(answer) }}
        </span>
                <span class="value">
          <span v-if="answer.fieldLabelFile">
            <ul>
              <li v-for="(url, index) in answer.files" :key="index" class="image-list-item">
                <img :src="prependHttps(url)" :alt="'Image ' + (index + 1)" @click="openModal(prependHttps(url))" />
              </li>
            </ul>
          </span>
          <span v-else>
            {{ getAnswerValue(answer) }}
          </span>
        </span>
            </div>
        </div>

        <div v-if="isModalVisible" class="modal-overlay" @click="closeModal">
            <div class="modal-content" @click.stop>
                <img :src="selectedImage" alt="Large Image" />
                <button class="close-button" @click="closeModal">X</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment/moment";

export default {
    name: "InboxContents",
    props: {
        answersData: {
            type: Object,
            required: true,
        },
        notReadBtn: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isModalVisible: false,
            selectedImage: "",
        };
    },
    computed: {
        formattedDate() {
            return moment(this.answersData.submission.createdAt).format("DD MMMM YYYY HH:mm");
        },
        sortedAnswers() {
            if (!this.answersData.answers) {
                return [];
            }
            let sorted = [];
            this.answersData.answers.forEach((answer) => {
                answer.value.forEach((valueItem) => {
                    sorted.push(valueItem.data);
                });
            });
            return sorted.sort((a, b) => a.order - b.order);
        },
    },
    methods: {
        ...mapActions({
            updateFormStatus: "forms/updateFormStatus",
        }),
        getLabelText(answer) {
            if (answer.username) {
                return "Kullanıcı adı: " + answer.username;
            }
            return (
                answer.fieldLabel ||
                answer.fieldEmail ||
                answer.fieldAddress ||
                answer.fieldPhone ||
                answer.fieldLabelFile ||
                "N/A"
            );
        },
        getAnswerValue(answer) {
            if (answer.firstName && answer.lastName) {
                return `${answer.firstName} ${answer.lastName}`;
            }
            if (answer.email) {
                return answer.email;
            }
            if (answer.fieldAddress) {
                return (
                    answer.addressLine1 +
                    " " +
                    answer.addressLine2 +
                    " " +
                    answer.city +
                    " " +
                    answer.state +
                    " " +
                    answer.postalCode
                );
            }
            if (answer.fieldPhone) {
                return answer.phoneNumber;
            }
            if (answer.fieldLabel) {
                if (answer.longText) {
                    return answer.longText;
                }
                if (answer.number) {
                    return answer.number;
                }
                if (answer.time) {
                    return answer.time + " " + answer.ampm;
                }
                if (answer.date) {
                    return moment(answer.date).format("DD MMMM YYYY HH:mm");
                }
                if (answer.subLabelOne) {
                    return answer.rating;
                }
                if (answer.rating) {
                    return this.renderStars(answer.rating);
                }
                if (answer.shortText) {
                    return answer.shortText;
                }
                if (answer.spinnerValue) {
                    return answer.spinnerValue;
                }
            }
            if (answer.username) {
                return "Tam Ad: " + answer.fullName;
            }
            if (answer.selected) {
                return answer.selected;
            }
            return "N/A";
        },
        prependHttps(url) {
            return `https://${url}`;
        },
        openModal(url) {
            this.selectedImage = url;
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
            this.selectedImage = "";
        },
        renderStars(rating) {
            return "★".repeat(rating) + "☆".repeat(5 - rating);
        },
        markAsRead() {
            this.updateFormStatus({
                siteId: this.answersData.submission.siteId,
                submissionId: this.answersData.submission._id,
                newStatus: "read",
            });
            this.$emit("mark-as-read");
        },
    },
};
</script>

<style lang="scss" scoped>
#inbox-content {
    font-family: 'Arial', sans-serif;
    height: 100%;
    overflow-y: auto;
    padding: 20px;
    color: #333;

    .content-header {
        border-bottom: 2px solid #ececec;
        padding-bottom: 10px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;

        h2 {
            margin: 0;
            font-size: 1.8rem;
            color: #333;
        }

        .button {
            background-color: #6f76a7;
            color: #fff;
            border: none;
            padding: 10px 20px;
            border-radius: 8px;
            cursor: pointer;
            transition: background-color 0.2s ease-in-out;

            &:hover {
                background-color: #5c628b;
            }
        }
    }

    .content-body {
        .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding: 15px;
            border-radius: 8px;
            background-color: #fff;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

            .label {
                color: #6f76a7;
                font-size: 1rem;
                font-weight: 600;
            }

            .value {
                color: #091551;
                font-size: 1rem;
                max-width: 500px;
                word-wrap: break-word;
            }

            .image-list-item {
                display: inline-block;
                width: 100px;
                margin-right: 10px;

                img {
                    width: 100%;
                    height: auto;
                    cursor: pointer;
                    transition: transform 0.2s ease-in-out;

                    &:hover {
                        transform: scale(1.05);
                    }
                }
            }
        }
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }

    .modal-content {
        position: relative;
        width: auto;
        height: auto;
    }

    .modal-content img {
        max-width: 900px;
        max-height: 900px;
    }

    .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: #fff;
        border: none;
        padding: 5px 10px;
        cursor: pointer;
    }
}
</style>
